import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "21",
  height: "21",
  viewBox: "0 0 21 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M17.877 0H2.416A2.417 2.417 0 0 0 0 2.416v15.46a2.417 2.417 0 0 0 2.416 2.417h15.46a2.417 2.417 0 0 0 2.417-2.416V2.416A2.417 2.417 0 0 0 17.877 0ZM6.28 7.73v9.18H3.382V7.73h2.9ZM3.382 5.06c0-.677.58-1.194 1.45-1.194s1.415.517 1.45 1.194c0 .676-.542 1.222-1.45 1.222-.87 0-1.45-.546-1.45-1.222ZM16.911 16.91h-2.9v-4.832c0-.966-.482-1.933-1.69-1.952h-.04c-1.168 0-1.652.995-1.652 1.952v4.832H7.732V7.73h2.899v1.236s.932-1.236 2.807-1.236c1.918 0 3.474 1.319 3.474 3.99v5.19Z",
      fill: "#FBBA00"
    }, null, -1)
  ]))]))
}
export default { render: render }